import React, { Component } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";

import EducationImg from "./EducationImg";
import "./EducationComponent.css";
import Educations from "./Educations"
import { useTranslation } from "react-i18next";

type Props = {theme: ThemeProps,}
export default function Education({ theme }: Props) {
	
	const { t, i18n } = useTranslation();
	
	 return (
		<PageLayout title="Home" theme={theme}>
			<div className="education-main">
				<Fade direction="up" duration={1000} triggerOnce={true} >
					<div className="heading-div">
              <div className="heading-img-div">
                {/* <img
									src={require("../../assests/images/education.svg")}
									alt=""
								/> */}
                <EducationImg theme={theme} />
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.text }}>
                  	{t("education.title")}
                </h1>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  {t("education.description")}
                </h3>
              </div>
            </div>
        </Fade>
				<Educations theme={theme} />
      </div>
		</PageLayout>
    );
}